import { render, staticRenderFns } from "./ArticleBoxesContainer.vue?vue&type=template&id=7474a922&scoped=true"
import script from "./ArticleBoxesContainer.vue?vue&type=script&lang=js"
export * from "./ArticleBoxesContainer.vue?vue&type=script&lang=js"
import style0 from "./ArticleBoxesContainer.vue?vue&type=style&index=0&id=7474a922&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7474a922",
  null
  
)

export default component.exports